import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { DetailPage } from "../detail/detail";
import { SearchService } from "../../providers/search";

@Component({
    selector: 'page-favorite-extern',
    templateUrl: 'favorite-extern.html'
})
export class FavoriteExternPage {

    extfavorites: any = [];
    loader;
    favList = {
        Structure: [],
        Folder: [],
        Document: [],
        Address: [],
        Meeting: []
    };

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public loadingCtrl: LoadingController,
                public searchService: SearchService) {

        this.extfavorites = navParams.get('favourites');
    }

    ionViewDidLoad() {
        for (var name in this.extfavorites) {
            this.getExternalFavorites(name);
        }
    }

    /**
     * Pushes the details view
     * @param id
     * @param type
     */
    getDetails(id, type) {
        this.navCtrl.push(DetailPage, {'objId': id, 'orgaStruct': type});
    }

    /**
     * Loads the external favorites from localStorage
     */
    getExternalFavorites(orgaStructure: string) {
        let ids: any = [];
        let extIds = this.extfavorites[orgaStructure];

        for (var i = 0; i < extIds.length; i++) {
            ids.push(extIds[i]._ObjID);
        }

        if (ids.length > 0) {
            this.searchService.getItemsById(ids, orgaStructure).subscribe(
                (result) => {
                    this.favList[orgaStructure] = result;
                }, (error) => {
                    console.error('getExternalFavorites Error: ', error);
                }
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/favorite-extern/favorite-extern.ts